module.exports = __webpack_public_path__ + "static/bwhorizontal-5da6bec11ca75dbc440fdda93ca06feb.svg";